<template>
	<div>
		<div style="float:right;margin-top:5px" v-if="syncCount!=0">
			<div class="spinner-border" style></div>
			<span style="color:red">Data is syncing</span>
		</div>
			<table class="table" style="table-layout:fixed;">
				<thead style="position: sticky;">
					<tr>
						<th width="3%">Status</th>
						<th width="2%">3D</th>
						<th class="link" v-on:click="sorting('client_name',$event)">
							Client Name
							<i
								class="sort fa"
								:class="sort.field=='client_name'? sort.order =='asc' ? 'fa-arrow-up':'fa-arrow-down':''"
							></i>
						</th>
						<th style class="link" v-on:click="sorting('go_retail',$event)">
							Director
							<i
								class="sort fa"
								:class="sort.field=='go_retail'? sort.order =='asc' ? 'fa-arrow-up':'fa-arrow-down':''"
							></i>
						</th>
						<th style class="link" v-on:click="sorting('go_marketing',$event)">
							Brand Manager
							<i
								class="sort fa"
								:class="sort.field=='go_marketing'? sort.order =='asc' ? 'fa-arrow-up':'fa-arrow-down':''"
							></i>
						</th>
						<th style class="link" v-on:click="sorting('go_ops',$event)">
							Search
							<i
								class="sort fa"
								:class="sort.field=='go_ops'? sort.order =='asc' ? 'fa-arrow-up':'fa-arrow-down':''"
							></i>
						</th>
						<th style class="link" v-on:click="sorting('go_dsp',$event)">
							DSP
							<i
								class="sort fa"
								:class="sort.field=='go_dsp'? sort.order =='asc' ? 'fa-arrow-up':'fa-arrow-down':''"
							></i>
						</th>
						<th style='width:9%' class="link" v-on:click="sorting('no_of_profile',$event)">
							# Ads
							<i
								class="sort fa"
								:class="sort.field=='no_of_profile'? sort.order =='asc' ? 'fa-arrow-up':'fa-arrow-down':''"
							></i>
						</th>
						<th style='width:9%' class="link" v-on:click="sorting('no_of_vendor',$event)">
							# Vendors
							<i
								class="sort fa"
								:class="sort.field=='no_of_vendor'? sort.order =='asc' ? 'fa-arrow-up':'fa-arrow-down':''"
							></i>
						</th>
						<th style='width:9%' class="link" v-on:click="sorting('no_of_seller',$event)">
							# Sellers
							<i
								class="sort fa"
								:class="sort.field=='no_of_seller'? sort.order =='asc' ? 'fa-arrow-up':'fa-arrow-down':''"
							></i>
						</th>
						<th style='width:9%' class="link" v-on:click="sorting('no_of_dsp',$event)">
							# DSP
							<i
								class="sort fa"
								:class="sort.field=='no_of_dsp'? sort.order =='asc' ? 'fa-arrow-up':'fa-arrow-down':''"
							></i>
						</th>
						<th style='width:9%' class="link" v-on:click="sorting('no_of_amc',$event)">
							# AMC
							<i
								class="sort fa"
								:class="sort.field=='no_of_amc'? sort.order =='asc' ? 'fa-arrow-up':'fa-arrow-down':''"
							></i>
						</th>
						<!-- <th>CMC</th>
						<th>MCT</th>
						<th>S/V?</th>-->
						<th style='width:10%' class="link" v-on:click="sorting('date_created',$event)">
							Created On
							<i
								class="sort fa"
								:class="sort.field=='date_created'? sort.order =='asc' ? 'fa-arrow-up':'fa-arrow-down':''"
							></i>
						</th>
						<th></th>
					</tr>
				</thead>
				<tbody>
					<tr
						v-for="(item, index) in accountsList"
						:key="item.profile_id + '_'+ item.ams_profile_id+'_'+ index"
						:class="index%2==0?'even':''"
					>
						<td>
							<div
								:id="index"
								style="
								height: 15.95px;
								width: 15.95px;
								border-radius: 20px;
								margin-left: 15px;
								cursor: pointer;
								"
								@mouseover="tooltipCode()"
								:class="setStateColor(item,index)"
								data-toggle="tooltip"
								:title="setTooltipState(item)"
								data-placement="bottom"
							></div>
						</td>
						<td>
                			<img v-if="item.go_initiative == 'Drive'" class="header-logo" src="@/assets/images/drive.png" width="30" height="30" alt="init-img" title="Drive"/>
							<img v-if="item.go_initiative == 'Dominate'" class="header-logo" src="@/assets/images/dominate.png" width="30" height="30" alt="init-img" title="Dominate"/>
							<img v-if="item.go_initiative == 'Deliver'" class="header-logo" src="@/assets/images/deliver.png" width="30" height="30" alt="init-img" title="Deliver"/>
						</td>
						<td style="word-break:break-all">
							<a href="javascript:void(0)" @click="viewDetails(item)" :style="boldedSearchResult(item.client_name)">{{item.client_name}}</a>
						</td>
						<td>{{item.go_retail_name}}</td>
						<td>{{item.go_brand_name}}</td>
						<td>{{item.go_marketing_name}}</td>
						<td>{{item.go_dsp_name}}</td>
						<td>
							<a
								href="javascript:void(0)"
								@click="viewListPopUp('Profile',item,item.profilecount)"
								:style="boldedSearchResult(item.profile_names)"
							>{{item.profilecount||0}}</a>
						</td>
						<td>
							<a
								href="javascript:void(0)"
								@click="viewListPopUp('Vendor',item,item.vendorcount)"
								:style="boldedSearchResult(item.vendor_names)"
							>{{item.vendorcount||0}}</a>
						</td>
						<td>
							<a
								href="javascript:void(0)"
								@click="viewListPopUp('Seller',item,item.sellercount)"
								:style="boldedSearchResult(item.seller_names)"
							>{{item.sellercount||0}}</a>
						</td>
						<td>
							<a
								href="javascript:void(0)"
								@click="viewListPopUp('DSP',item,item.dspcount)"
								:style="boldedSearchResult(item.dsp_names)"
							>{{item.dspcount||0}}</a>
						</td>
						<td>
							<a
								href="javascript:void(0)"
								@click="viewListPopUp('AMC',item,item.amccount)"
								:style="boldedSearchResult(item.amc_names)"
							>{{item.amccount||0}}</a>
						</td>
						<td>{{ShowCreatedOn(item.created_on)}}</td>
						<td class="row-add-edit" v-if="syncCount == 0">
							<div class="row-add-edit" v-if="isUserAdmin || isSuperUser || hasAccountAccess(item.client_id)">
								<a href="javascript:void(0)" class="item-add-edit" data-toggle="dropdown"></a>
								<div
									class="dropdown-menu"
									aria-labelledby="dropdownMenuButton"
									style="left:-58px"
									
								>
									<a class="grid-item ico-edit remove-padding" @click="editVendor(item)" v-if="item.is_active">Edit</a>
									<a class="grid-item ico-delete remove-padding" @click="removeVendor(item,true)" v-if="!item.is_active && isUserAdmin">Enable</a>
									<a class="grid-item ico-delete remove-padding" @click="removeVendor(item,false)" v-else-if="item.is_active && isUserAdmin">Disable</a>
								</div>
							</div>
						</td>
						<td v-else></td>
					</tr>
				</tbody>
			</table>
		<ListNamesPopUp
			ref="listPopUp"
			:namesArray="listItems"
			:type="listType"
			:clientName="clientName"
			:showSpinner="fetchingItem"
		/>
		<DeleteSingleProductConfirmModal
			@deleteSelectedProducts="deleteAction"
			:notDeleted="false"
			:delHeaderMsg="updateHeading(delClientName)"
			:isDiffMsg = "popupTitle"
			@hideAction="hideAction"
		></DeleteSingleProductConfirmModal>
	</div>
</template>

<script>
	import moment from "moment";
	import ListNamesPopUp from "./ListNamesPopUp.vue";
	import DeleteSingleProductConfirmModal from "@/components/product/DeleteSingleProductConfirmModal";

	export default {
		name: "AccountsListGrid",
		props: ["isExportExcel"],
		data() {
			return {
				listItems: [],
				listType: "",
				clientName: "",
				fetchingItem: false,
				delClientId:null,
				delClientName:'',
				set_client_active : null,
				isUserAdmin: this.$store.state.isUserAdmin,
				isSuperUser: this.$store.state.auth.isSuperUser,
			};
		},
		components: {
			ListNamesPopUp,
			moment,
			DeleteSingleProductConfirmModal
		},
		watch: {},
		computed: {
			popupTitle:{
				get(item){
					return `Are you sure, you want to ${this.set_client_active ?  'Enable':'Disable'} this client?`
				}
			},
			sort: {
				set(val) {
					this.$store.commit("setSelectedSortOrder", val);
				},
				get() {
					return this.$store.state.selectedSortOrder;
				}
			},
			accountsList: {
				set(val) {
					this.$store.commit("accounts/updateAccountList", val);
				},
				get() {
					return this.$store.getters["accounts/getAccountList"];
				}
			},
			syncCount: {
				get() {
					return this.$store.getters["accounts/getSyncCount"];
				}
			}
		},
		async mounted() {
			this.$store.state.auth.accountRoles = await this.$store.dispatch("auth/getAccountRoles")
		},
		methods: {
			hasAccountAccess(client_id) {
				return this.$store.getters["auth/hasAccountAccess"](client_id)
			},
			boldedSearchResult(data){
				if (!data) {
					return 'color: #143A33;'
				}

				if (this.$store.state.searchFilterString && data.toLowerCase().includes(this.$store.state.searchFilterString.toLowerCase())) {
					return 'color: #143A33; font-weight: bold;'
				}

				return 'color: #143A33;'
			},
			tooltipCode() {
			$('[data-toggle="tooltip"]').tooltip();
			},
			setTooltipState(client) {
			if (client && client.is_active && client.is_active == true) {
				return "Enabled";
			} else {
				return "Disabled";
			}
			},
			setStateColor(client,index) {
				 if (client && client.is_active && client.is_active == true) {
					return "active_color";
				} else {
					return "disabled_color";
				}
				},
			hideAction(){
				this.delClientName = ''
			},
			updateHeading(data){
				data = `${this.set_client_active ? 'Enable':'Disable'} "` + data + '"'
				return data
			},
			getProfileData(client_id) {
				let vm = this;
				if (client_id) {
					this.$store
						.dispatch("accounts/getDetails", { client_id: client_id })
						.then(resp => {
							if (
								resp &&
								resp.profileData &&
								resp.profileData.length
							) {
								vm.listItems = resp.profileData.map(item => {
									let name = item.profile_brand_name ? item.profile_brand_name + ' (' : "";
									name = name + item.brand_entity_id + (item.profile_brand_name ? ')' : "");
									item["customName"] = name
									return item;
								});
								vm.listItems = vm.listItems.sort((a, b) => new Date(b.date_created) - new Date(a.date_created))
							}

							vm.fetchingItem = false;
						});
				}
			},
			viewListPopUp(type, item, count) {
				const vm = this;
				this.listType = type;
				this.clientName = item.client_name;
				if (!count) {
					vm.listItems = [];
					this.$refs["listPopUp"].openPopUp();
					return;
				}
				this.fetchingItem = true;
				this.$refs["listPopUp"].openPopUp();
				if (this.listType == "Profile") {
					this.getProfileData(item.client_id);
					return;
				}
				this.$store
					.dispatch("accounts/getListItems", {
						type: type,
						client_id: item.client_id
					})
					.then(resp => {
						vm.listItems = resp;
						vm.fetchingItem = false;
					});
			},
			sorting(field, event) {
				if (
					event.currentTarget.children[0].classList[2] == "fa-arrow-up" ||
					event.currentTarget.children[0].classList[2] == "fa-arrow-down"
				) {
					var pastEvent = true;
				}
				for (
					var i = 0;
					i < document.getElementsByClassName("sort").length;
					i++
				) {
					document
						.getElementsByClassName("sort")
						[i].classList.remove("fa-arrow-up");
					document
						.getElementsByClassName("sort")
						[i].classList.remove("fa-arrow-down");
				}
				if (pastEvent) {
					this.sort.order == "desc"
						? event.currentTarget.children[0].classList.add(
								"fa-arrow-up"
						  )
						: event.currentTarget.children[0].classList.add(
								"fa-arrow-down"
						  );
					pastEvent = false;
				} else {
					event.currentTarget.children[0].classList.add("fa-arrow-up");
				}

				this.sort = {
					field: field,
					order:
						event.currentTarget.children[0].classList[2] ==
						"fa-arrow-up"
							? "asc"
							: "desc"
				};

				// this.$store.state.sort.field = field;
				// this.$store.state.sort.order = (event.currentTarget.children[0].classList[2]) == 'fa-angle-up' ? 'asc':'desc';
			},
			ShowCreatedOn(data) {
				return moment(data).format("MM/DD/YYYY");
			},
			editVendor(item) {
				if (item.client_id) {
					this.$router.push({
						path: "/addVendor" + "/" + item.client_id
					});
				}
			},
			getCampType(item) {
				var arr = [];
				if (item.marketing_campaign_sb) {
					arr.push("SB");
				}
				if (item.marketing_campaign_sp) {
					arr.push("SP");
				}
				if (item.marketing_campaign_sd) {
					arr.push("SD");
				}
				return arr.join(", ");
			},
			sellerOrVendor(item) {
				if (item && item.profile_type_seller && item.profile_type_vendor) {
					return "Seller, Vendor";
				} else if (item && item.profile_type_seller) {
					return "Seller";
				} else if (item && item.profile_type_vendor) {
					return "Vendor";
				} else return "";
			},
			viewDetails(item) {
				//let vendorId = item.go_vendor_cd ? item.go_vendor_cd : null;
				if (item.client_id) {
					this.$router.push({
						path: "/accountDetails" + "/" + item.client_id + '/' + btoa(item.client_name)
						// +
						// "/" +
						// item.profile_brand_name +
						// "/" +
						// item.profile_id +
						// "/" +
						// vendorId
					});
				}
				// else {
				// 	this.$router.push({
				// 		path:
				// 			"/accountDetails/profile" +
				// 			"/" +
				// 			item.profile_id +
				// 			"/" +
				// 			item.profile_brand_name +
				// 			"/" +
				// 			item.profile_id +
				// 			"/" +
				// 			vendorId
				// 	});
				// }
			},
			removeVendor(data,active){
				this.delClientId = data.client_id;
				this.delClientName = data.client_name
				this.set_client_active = active
				$('#confirmSingleDeleteProduct').modal('show')
			},
			deleteAction(){
				let payload = {
					client_id:this.delClientId,
					client_name:this.delClientName,
					is_active:this.set_client_active
				}
			//	$('#confirmSingleDeleteProduct').modal('hide');
				let vm = this;
				this.$store.dispatch("accounts/delClient", payload).then((res) => {
					this.delClientId = null;
					this.delClientName = ''
					this.set_client_active = null
					this.$emit('filterList')
				})
			}
		}
	};
</script>

<style lang="scss">
.show_green {
	background-color: green;
}
.show_red {
	background-color: red;
}
.remove-padding{
	padding-top: 0px !important;
	padding-bottom: 0px !important;
}
</style>
